import { Reducer } from 'redux';
import { GroupResponse } from '../../models/group/group-response.model';
import {
   GROUP_LIST, GROUP_LIST_ERROR, GROUP_LIST_SUCCESS, PRODUCTS_GROUP, PRODUCTS_GROUP_ERROR, PRODUCTS_GROUP_SUCCESS
} from '../contants';

type GroupInitStateType = {
    groups: any | GroupResponse;
    groupId: number | null;
    products: any;
    loading: boolean;
    loadingProducts: boolean;
    error: boolean;
    errorMessage: string;
}

const INIT_STATE = {
    groups: [],
    groupId: null,
    products: [],
    loading: false,
    loadingProducts: false,
    error: false,
    errorMessage: '',
};

const GroupReducer: Reducer<GroupInitStateType> = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case GROUP_LIST:
      return { ...state, loading: true, error: false };
    case GROUP_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            groups: action.payload,
            error: false,
        };
    case GROUP_LIST_ERROR:
        return {
            ...state,
            loading: false,
            groups: [],
            error: true,
            errorMessage: action.payload.message,
        };
    case PRODUCTS_GROUP:
      return { ...state, loadingProducts: true, error: false };
    case PRODUCTS_GROUP_SUCCESS:
        return {
            ...state,
            loadingProducts: false,
            groupId: action.payload.groupId,
            products: action.payload.productsOfGroup,
            error: false,
        };
    case PRODUCTS_GROUP_ERROR:
        return {
            ...state,
            loadingProducts: false,
            products: [],
            error: true,
            errorMessage: action.payload.message,
        };
    default:
      return { ...state };
  }
};

export default GroupReducer;
